module.exports = __webpack_public_path__ + "static/media/scissor-lifts-booms.c360de44.jpg";